(function () {
  'use strict';

  var alertTimeout = 5000;
  angular.module('wsLrs.controllers').controller('ImportGroupsCtrl', ['$http', '$scope', '$timeout', 'Api', 'CsvUpload', 'CSVParserRegistry', function ($http, $scope, $timeout, Api, CsvUpload, CSV) {
    $scope.exampleCsvUrl = Api.url("/group-import/example");
    $scope.parserMap = CSV.getParserMap();
    $scope.parsers = _.keys($scope.parserMap);
    $scope.selectedParser = $scope.parsers.length ? $scope.parsers[0] : null;
    $scope.alerts = [];
    function getCsvUpload() {
      return new CsvUpload($scope.parserMap[$scope.selectedParser]);
    }
    var csvUpload = getCsvUpload();
    $scope.selectParser = function selectParser(parser) {
      $scope.selectedParser = parser;
      csvUpload = getCsvUpload();
    };
    $scope.setFiles = function (element) {
      $scope.$apply(function () {
        var result = csvUpload.setFiles(element);
        if (result === false) {
          $scope.alerts.push({
            text: "All files must be of type CSV.",
            type: "danger"
          });
        }
        $scope.importFiles(result);
      });
    };
    $scope.importFiles = function importFiles(files) {
      if (!files || files.length < 1) {
        //show error on alert
        $scope.$safeApply(function () {
          $scope.alerts.push({
            text: 'No file selected.',
            type: 'danger'
          });
        });
        return;
      }
      function groupExportFinished(job) {
        var alert = {
          timeout: alertTimeout,
          type: "success",
          text: job.messages
        };
        if (job.status === "aborted") {
          alert.type = "warning";
        } else {
          alert.text = "Group hierarchy data has been successfully imported. " + alert.text;
        }
        $scope.progress = null;
        $scope.alerts.push(alert);
      }
      csvUpload.uploadFiles(files).then(function (jobId) {
        $scope.alerts.push({
          text: 'Group hierarchy data is being imported.',
          type: "success",
          timeout: alertTimeout
        });
        $scope.progress = {
          percent: 0
        };
        return csvUpload.waitForCompletion(jobId);
      }, function (e) {
        var response = angular.fromJson(e.target.responseText);
        if (response.exceptionMessage) {
          $scope.alerts.push({
            text: response.exceptionMessage,
            type: "danger"
          });
        }
      }).then(groupExportFinished, groupExportFinished, function progress(status) {
        // temp fix for "bouncing" progress due to load balancing of servers
        // ignore default status from servers not actually running our job
        if (status.percentage > 0 && status.status !== "submitted") {
          $scope.$safeApply(function () {
            $scope.progress.percent = status.percentage;
            $scope.progress.message = status.messages;
          });
        }
      });
    };
  }]);
})();
